import { FC, Fragment, useMemo } from 'react';

import { useBrandAffinityXAIContext } from 'modules/ai/XAI/audienceUserProfile';

import { EngagementData } from './EngagementData';
import { getCombinedEngagementData } from '../utils';
import { EngagementSkeleton } from './EngagementSkeleton';
import { DataContainer, EngagementTitle } from './EngagementCard.styles';
import { Card, ContentDivider } from '../Styles';

export const EngagementHistory: FC = () => {
  const { isError, isLoading, affinityData } = useBrandAffinityXAIContext();

  const engagementData = useMemo(
    () => getCombinedEngagementData(isError, affinityData?.userStats),
    [isError, affinityData?.userStats],
  );

  if (isLoading) {
    return <EngagementSkeleton />;
  }

  return (
    <Card data-test="brand-affinity-xai-engagement">
      <EngagementTitle>Most impactful metrics</EngagementTitle>
      <DataContainer>
        {engagementData.map(
          ({ count, eventType, isDefault, labelCompare, median }, index, source) => (
            <Fragment key={`${eventType}_${count}`}>
              <EngagementData
                eventType={eventType}
                isDefault={isDefault}
                count={count}
                labelCompare={labelCompare}
                median={median}
              />
              {index + 1 !== source.length ? <ContentDivider /> : null}
            </Fragment>
          ),
        )}
      </DataContainer>
    </Card>
  );
};
